<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup lang="ts">
import '@qicgroupdoha/qic-connect-ds/style.css';

useHead({
  script: [
    {
      innerHTML: `window.renderedAt = "${new Date().toLocaleString()}";`
    },
    {
      async: true,
      src: 'https://www.googletagmanager.com/gtag/js?id=G-VRPMCST53D'
    },
    {
      innerHTML: `
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
gtag('config', 'G-VRPMCST53D');`
    },
    {
      innerHTML: `
(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-5LFKBJN');`
    },
  ],
})
</script>
